import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";
import { useRef } from "react";

function DraggablePaper(props) {
  const nodeRef = useRef(null);

  return (
    <Draggable
      nodeRef={nodeRef}   // ✅ REQUIRED
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], .MuiIconButton-root'}
    >
      <Paper ref={nodeRef} {...props} />
    </Draggable>
  );
}

export default DraggablePaper;
